"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BalanceEncouragement = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../shared/core");
var copy_1 = require("../../../../copy");
var sandwich_ids_1 = require("../../../../sandwich-ids");
var ApplyForRefund_styled_1 = require("../../ApplyForRefund.styled");
var Switcher_1 = require("./Switcher");
var BalanceEncouragement = function () {
    var _a = (0, core_1.useComponents)(), Heading2 = _a.Heading2, Heading3 = _a.Heading3, Card = _a.Card, Margin = _a.Margin, VisuallyHidden = _a.VisuallyHidden;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    return (react_1.default.createElement(Card, null,
        react_1.default.createElement(Margin, { bottom: 8 },
            react_1.default.createElement(Heading2, null,
                react_1.default.createElement(Copy, { copyKey: "encourageTitle" }))),
        react_1.default.createElement(VisuallyHidden, null,
            react_1.default.createElement(Heading3, null,
                react_1.default.createElement(Copy, { copyKey: "encourageHeading" }))),
        react_1.default.createElement(Switcher_1.Switcher, { threshold: "40rem", element: "ul" },
            react_1.default.createElement(ApplyForRefund_styled_1.StyledDdIncreaseExplainerLi, null,
                react_1.default.createElement(ui_tools_1.Sandwich, { id: sandwich_ids_1.sandwichIds.applyForARefund.balanceEncouragement
                        .directDebitExplanation },
                    react_1.default.createElement(ApplyForRefund_styled_1.StyledUsageImage, { "aria-hidden": "true" })),
                react_1.default.createElement(Copy, { copyKey: "encourageDirectDebitExplanation" })),
            react_1.default.createElement(ApplyForRefund_styled_1.StyledDdIncreaseExplainerLi, null,
                react_1.default.createElement(ui_tools_1.Sandwich, { id: sandwich_ids_1.sandwichIds.applyForARefund.balanceEncouragement.splitExplanation },
                    react_1.default.createElement(ApplyForRefund_styled_1.StyledRadiatorImage, { "aria-hidden": "true" })),
                react_1.default.createElement(Copy, { copyKey: "encourageSplitExplanation" })),
            react_1.default.createElement(ApplyForRefund_styled_1.StyledDdIncreaseExplainerLi, null,
                react_1.default.createElement(ui_tools_1.Sandwich, { id: sandwich_ids_1.sandwichIds.applyForARefund.balanceEncouragement.refundExplanation },
                    react_1.default.createElement(ApplyForRefund_styled_1.StyledMoneyImage, { "aria-hidden": "true" })),
                react_1.default.createElement(Copy, { copyKey: "encourageRefundExplanation" })))));
};
exports.BalanceEncouragement = BalanceEncouragement;
